<div class="activities-body" style="margin-bottom:130px;">
    <img src="assets/imgs/Chater_Flight.jpg" width="90%">
</div>